"use client"

import type { FunctionComponent } from "react"

import { Loader } from "@jobteaser/spark/components/Icons/Loader"
import { Link } from "@jobteaser/spark/components/Link"

import { useTranslation } from "@/modules/i18n/components/useTranslation"
import { useLocale } from "@/modules/locales/useLocale"
import { ApprovalPageContent } from "@/modules/termsAndConditions/ApprovalPage/ApprovalPageContent"

import styles from "./ApprovalPage.module.css"

export const ApprovalPage: FunctionComponent = () => {
  const locale = useLocale()
  const { ready, t, tReact } = useTranslation(["terms_and_conditions", "shared_a11y"], true)

  if (!ready)
    return (
      <main className={styles.loader}>
        <Loader />
      </main>
    )

  const generalTermsLink = (
    <Link
      externalLinkHiddenText={t("shared_a11y.link_opens_in_new_tab")}
      href={`/${locale}/about/terms-for-members`}
      rel="noopener noreferrer"
      target="_blank"
      variant="body2"
    >
      {t("terms_and_conditions.approval.general_terms_link")}
    </Link>
  )

  const privacyPolicyLink = (
    <Link
      externalLinkHiddenText={t("shared_a11y.link_opens_in_new_tab")}
      href={`/${locale}/about/privacy-policy`}
      rel="noopener noreferrer"
      target="_blank"
      variant="body2"
    >
      {t("terms_and_conditions.approval.privacy_policy_link")}
    </Link>
  )

  return (
    <ApprovalPageContent
      explanation={t("terms_and_conditions.approval.explanation")}
      text={tReact("terms_and_conditions.approval.text", {
        general_terms_link: generalTermsLink,
        privacy_policy_link: privacyPolicyLink,
      })}
      title={t("terms_and_conditions.approval.title")}
      validate={t("terms_and_conditions.approval.validate")}
    />
  )
}
